import * as React from "react";
import { useEffect } from "react";

import { IProps, IProviderProps, Sections } from "./IProps";

/**
 * Create React Context will Provider
 * All below Child component can able to Consume
 * @param {IProviderProps} - CustomAddButtonsWrapperContext Provider
 * @category CustomContext
 */
export const CustomAddButtonsWrapperContext = React.createContext<IProviderProps>({
    hasSection: false,
    sections: {},
});

/**
 * @class CustomAddButtonsWrapper
 * @param props
 * @description
 * This component acts as a wrapper of multiple CustomAddButton Components.
 * Used at `Property Manager`, `Addendum` and `Catalog of Accessories`
 * @category Wrapper
 */
class CustomAddButtonsWrapper extends React.Component<IProps> {
    // componentDidMount

    /**
     * Find any properties key have a `Section` word in key
     * @param properties
     */
    hasSectionInProps = (properties) => Object.keys(properties).some((key) => key.includes("Section"));

    /**
     * Get section object data
     * @param properties
     */
    getSections = (properties) => {
        return Object.keys(properties)
            .filter((key) => key.includes("Section"))
            .map((section) => {
                return {
                    title: section,
                    sectionId: properties[section].const.sectionId,
                    requiredCount: properties[section].const.requiredCount,
                };
            });
    };

    /**
     * Get non section object data
     * @param properties
     * @param formData
     */
    getSubSections = (properties, formData) => {
        return Object.keys(properties)
            .filter((key) => !key.includes("Section") && properties[key].const.sectionId !== undefined)
            .map((section) => {
                return {
                    title: section,
                    sectionId: properties[section].const.sectionId,
                    show: formData[section] === "SHOW",
                };
            });
    };

    /**
     * Get section / non section data to render title
     * @return IProviderProps
     */
    getSectionData = (): IProviderProps => {
        let sectionHead, subSections;
        const sections: Sections = {};

        const { children, schema: { properties = {} } = {} } = this.props;
        const {
            props: { formData },
        } = children[0];

        const hasSection = this.hasSectionInProps(properties);

        if (hasSection) {
            sectionHead = this.getSections(properties);
            subSections = this.getSubSections(properties, formData);

            for (const section of sectionHead) {
                const specificSection = subSections.filter((subSec) => subSec.sectionId === section.sectionId);
                sections[section.sectionId] = {
                    selectedCount: specificSection.filter((subSec) => subSec.show).length,
                    totalCount: specificSection.length,
                };
            }
        }

        return {
            hasSection,
            sections,
        };
    };

    /**
     * Update React Context Provider Name
     * Helpful for debug
     */
    /*updateContextName = () => {
        const { label } = this.props;
        if (label) {
            const contextName = label.charAt(0).toUpperCase() + label.slice(1);
            CustomAddButtonsWrapperContext.displayName = `${contextName}Context`;
        }
    };*/

    render() {
        const { children, classNames } = this.props;
        if (
            children &&
            children[0] &&
            children[0].props &&
            children[0].props.schema &&
            children[0].props.schema.const["ui:order"]
        ) {
            children[0].props.uiSchema["ui:order"] = children[0].props.schema.const["ui:order"];
        }
        // this.updateContextName();
        return (
            <div className={classNames}>
                <CustomAddButtonsWrapperContext.Provider value={this.getSectionData()}>
                    {children}
                </CustomAddButtonsWrapperContext.Provider>
            </div>
        );
    }
}

export default CustomAddButtonsWrapper;
